import styled from "styled-components";

export const SearchContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    
    max-width: 540px;
    height: 44px;

    background: white;
    border-radius: 999px;
    padding: 0 18px;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
`;

export const SearchInput = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;

    font-size: 16px;
    color: var(--bs-secondary);

    &::placeholder {
        color: #9c9c9c;
    }
`;

export const SearchIconWrapper = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #9c9c9c;

    svg {
        font-size: 26px;
    }

    &:hover {
        color: var(--bs-primary);
    }
`;
